// Task editor 공통 스크롤바 외형. 스크롤이 있는 컨테이너의 sx 에 spread 해서 쓴다.
// 외형(얇은 둥근 thumb) 만 담는다 — scrollbarGutter 같은 레이아웃 reserve 는
// 필요한 컨테이너에서 개별로 추가한다 (드롭다운 등에 일괄 적용 시 폭이 틀어지므로).
export const taskEditorScrollbarSx = {
  "&::-webkit-scrollbar": { width: "8px", height: "8px" },
  "&::-webkit-scrollbar-track": { background: "transparent" },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "rgba(0,0,0,0.18)",
    borderRadius: "4px",
  },
  "&:hover::-webkit-scrollbar-thumb": {
    backgroundColor: "rgba(0,0,0,0.28)",
  },
} as const;
